import { Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Button from '../../Button';
import { FaTrash } from 'react-icons/fa';

const KeyValueEditor = ({ keyPair, setKeyPair, onKeyPairRemove, handleContextMenu }) => {
  const [keyValue, setKeyValue] = useState(keyPair);
  const [debouncedKeyValue, setDebouncedKeyValue] = useState(keyValue);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedKeyValue(keyValue);
    }, 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, [keyValue]);

  useEffect(() => {
    setKeyPair(debouncedKeyValue);
    // eslint-disable-next-line
  }, [debouncedKeyValue]);

  const handleOnChange = (e) => {
    setKeyValue((prevState) => ({
      ...prevState,
      id: keyValue.id,
      [e.target.name]: e.target.value,
    }));
  };
  return (
    <Grid container spacing={1} direction="row" sx={{ pt: 1 }}>
      <Grid item xs={5}>
        <TextField
          id="name"
          label="Key"
          variant="outlined"
          placeholder=""
          size="small"
          fullWidth
          name="keyItem"
          onChange={(e) => handleOnChange(e)}
          defaultValue={keyPair.keyItem}
        />
      </Grid>
      <Grid item xs={5}>
        <TextField
          id="name"
          label="Value"
          variant="outlined"
          placeholder=""
          size="small"
          fullWidth
          name="valueItem"
          defaultValue={keyPair.valueItem}
          onChange={(e) => handleOnChange(e)}
          onContextMenu={handleContextMenu}
        />
      </Grid>
      <Grid item xs={2}>
           <Button variant="contained" rounded  size='small' onClick={() => onKeyPairRemove(keyPair)} sx={{mt:'-1px'}}>Remove</Button>     
           {/* <div>
           <FaTrash color="info" title="Delete" onClick={() => onKeyPairRemove(keyPair)} className="cursor-pointer" />
           </div> */}
      </Grid>
    </Grid>
  );
};

export default KeyValueEditor;
